import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { until } from 'protractor';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { UserService } from './user.service';

//Menu Bar
export interface Menu {
  headTitle?: string;
  title?: string;
  path?: string;
  icon?: string;
  type?: string;
  badgeClass?: string;
  badgeValue?: string;
  active?: boolean;
  module?: string,
  children?: Menu[];
  section?:number,
  toSupervisor?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class NavService implements OnDestroy {

  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  public megaMenu: boolean = false;
  public megaMenuCollapse: boolean = window.innerWidth < 1199 ? true : false;
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;
  private permissions: any;
   private permissionsEmp: any;
  
  constructor(
    private router: Router,
    private users: UserService
  ) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize').pipe(
      debounceTime(1000),
      takeUntil(this.unsubscriber)
    ).subscribe((evt: any) => {
      this.setScreenWidth(evt.target.innerWidth);
      if (evt.target.innerwidth < 991) {
        this.collapseSidebar = false;
        this.megaMenu = false;
      }

      if (evt.target.innerWidth < 1199) {
        this.megaMenuCollapse = true;
      }
    });
    if (window.innerWidth < 991) {
      this.router.events.subscribe(event => {
        this.collapseSidebar = false;
        this.megaMenu = false;
      })
    }
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  getModules(){ 

    let MENUITEMS : Menu[] = [
      //mi kiosko
      { headTitle: 'Mi Kiosko', section:0},
      { path: '/analitics', title: 'Analíticos', type: 'link', icon: 'mdi mdi-apps', active: false, module: "analitics", section:0 },
      { path: '/payroll', title: 'Carga de Información', type: 'link', icon: 'zmdi zmdi-dns', active: false, module: "payroll", section:0 },
      { path: '/letters', title: 'Cartas', type: 'link', icon: 'zmdi zmdi-email', active: false, module: "letters", section:0 },
      { path: '/cafeteria', title: 'Comedor', type: 'link', icon: 'zmdi zmdi-cutlery', active: false, module: "cafeteria", section:0 },
      { path: '/credentials', title: 'Credenciales', type: 'link', icon: 'mdi mdi-account-card-details', active: false, module: "credentials", section:0 },
      { path: '/employees', title: 'Empleados', type: 'link', icon: 'mdi mdi-account-multiple', active: false, module: "employees", section:0 },
      { path: '/surveys', title: 'Encuestas', type: 'link', icon: 'mdi mdi-view-list', active: false, module: "surveys", section:0 },
      { path: '/metrics', title: 'Métricos', type: 'link', icon: 'fa fa-bar-chart', active: false, module: "metrics", section:0 },
      { path: '/news', title: 'Noticias', type: 'link', icon: 'zmdi zmdi-collection-text', active: false, module: "news", section:0 },
      { path: '/receipts', title: 'Recibos', type: 'link', icon: 'zmdi zmdi-file-text', active: false, module: "receipts", section:0 },
      { path: '/reports', title: 'Reportes', type: 'link', icon: 'zmdi zmdi-assignment', active: false, module: "reports", section:0 },
      { path: '/routes', title: 'Transporte', type: 'link', icon: 'mdi mdi-bus', active: false, module: "routes", section:0 },
      { path: '/uniforms', title: 'Uniformes', type: 'link', icon: 'mdi mdi-archive', active: false, module: "uniforms", section:0 }, //revisar icono
      { path: '/vacations', title: 'Vacaciones', type: 'link', icon: 'fa fa-umbrella-beach', active: false, module: "vacations", section:0 },
      // { title: 'Evaluaciones', type: 'sub', icon: 'fa fa-tasks', active: false, section:0, module: "evaluations", children: evaluations },
     
      //Evaluaciones
      { headTitle: this.users?.user?.evaluationsConfig?.labels?.evaluations || 'Evaluaciones', section: 2 },
      {path: '/goals', title: "Objetivos", type: 'link', icon: 'fa fa-star', module: "goals", active:false ,section:2 },// Goals
      {path: '/narratives', title: "Narrativas", type: 'link', icon: 'fa fa-newspaper-o', module: "narratives", active:false ,section:2 },// Narrativas
      {path: '/results', title: "Resultados", type: 'link', icon: 'fa fa-certificate', module: "narratives", active:false ,section:2 },// Resultados

      //checador
      { headTitle: 'Checador', section: 3 },
      { path: '/checker', title: 'Checador', type: 'link', icon: 'mdi mdi-cellphone', active: false, module: "checker", section:3 },
      { path: '/checker-bus', title: 'Checador BUS', type: 'link', icon: 'mdi mdi-bus', active: false, module: "checker-bus", section:3 },
      //inventario
      { headTitle: 'Inventario', section:4 },
      { path: '/inventory', title: 'Inventario', type: 'link', icon: 'mdi mdi-cube', active: false, module: "inventory", section:4 },

      //Plan Carrera
      { headTitle: 'Plan Carrera', section:5 },
      { path: '/career-path', title: 'Plan Carrera', type: 'link', icon: 'mdi mdi-compass', active: false, module: "career-path", section:5 },
      { path: '/vacancies', title: 'Vacantes', type: 'link', icon: 'mdi  mdi-tie', active: false, module: "vacancies", section:5 },
      { path: '/catalogs', title: 'Catalogos', type: 'link', icon: 'mdi  mdi-library', active: false, module: "catalogs", section:5 },

      //usuarios
      { headTitle: 'Cuenta', section:6 },
      { path: '/users', title: 'Usuarios', type: 'link', icon: 'mdi mdi-account', active: false, module: "users", section:6 },
      { path: '/configurations', title: 'Configuraciones', type: 'link', icon: 'mdi mdi-settings', active: false, module: "configurations", section:6 },
      { path: '/docs', title: 'Documentación', type: 'link', icon: 'mdi mdi-file-document-box', active: false, module: "docs", section:6 },
      //{ path: '/', title: 'Facturación', type: 'link', icon: 'fa fa-credit-card', active: false },
      { path: '/supports', title: 'Soporte', type: 'link', icon: 'fa fa-question-circle', active: false, module: "supports", section:6 },
      
    ]

    let MENUITEMSEMPLOYEE : Menu[] = [
      //mi kiosko
      { headTitle: 'Mi Kiosko', section:0},
      { path: '/emp/employee-home', title: 'Inicio', type: 'link', icon: 'mdi mdi-home', active: false, module: "employee-home", section:0 },
      //Plan Carrera
      { headTitle: 'Plan Carrera', section:1 },
      { path: '/emp/employee-vacancies', title: 'Vacantes', type: 'link', icon: 'mdi mdi-tie', active: false, module: "employee-vacancies", section:1 },
      //Evaluaciones
      { headTitle: this.users?.user?.evaluationsConfig?.labels?.evaluations || 'Evaluaciones', section:2 },
      { path: '/emp/employee-objetives', title: "Objetivos", type: 'link', icon: 'fa fa-star', module: "employee-objetives", active:false ,section:2 },
      { path: '/emp/employee-reviews', title: "Revisiones", type: 'link', icon: 'fa fa-check', module: "employee-reviews", active:false ,section:2 },
      { path: '/emp/employee-objetives-results', title: "Resultados", type: 'link', icon: 'fa fa-certificate', module: "employee-objetives-results", active:false ,section:2 },
      //Checador
      { headTitle: "Checador", section:3 },
      { path: '/emp/employee-checker', title: "Checador", type: 'link', icon: 'mdi mdi-cellphone', module: "employee-checker", active:false ,section:3 },
    ]

    this.permissions = this.users.user.permissions;
    this.permissionsEmp = this.users.user.permissionsEmp;

    if(this.users.user.employeeType){
      MENUITEMS = MENUITEMSEMPLOYEE;
      //Elimina los modulos que no se tiene permisos
      MENUITEMS = MENUITEMS.filter(menu => (!menu.module || this.permissionsEmp?.[menu.module]?.access) && (this.permissionsEmp?.[menu.module]?.toSupervisor ? this.users?.user?.supervisor : true));
      const index = MENUITEMS.findIndex(menu => menu.module);
      if (index && MENUITEMS?.length) {
        MENUITEMS[index].active = true;
      }

    } else{ 
      if (this.users.user.roleName != "ADMIN") {
        //Elimina los modulos que no se tiene permisos
        MENUITEMS = MENUITEMS.filter(menu => !menu.module || this.permissions?.[menu.module]?.access);
        
        // Asegurar que el módulo de Documentación siempre esté presente
        // const hasDocsModule = MENUITEMS.some(menu => menu.module === 'docs');
        // if (!hasDocsModule) {
        //   // Encontrar el módulo de docs en el menú original
        //   const docsModule = { 
        //     path: '/docs', 
        //     title: 'Documentación', 
        //     type: 'link', 
        //     icon: 'mdi mdi-file-document-box', 
        //     active: false, 
        //     module: "docs", 
        //     section: 6 
        //   };
        //   MENUITEMS.push(docsModule);
        // }
        
        const index = MENUITEMS.findIndex(menu => menu.module);
        if (index && MENUITEMS?.length) {
          MENUITEMS[index].active = true;
        }
      }
    }

    //Elimina los titulos que no cuentan con modulo
    let hist = {};
    MENUITEMS.map( function (a) { if (a.section in hist) hist[a.section] ++; else hist[a.section] = 1; } );
    MENUITEMS = MENUITEMS.filter(menu => hist[menu.section] > 1);

        
    return new BehaviorSubject<Menu[]>(MENUITEMS);
  }
}
